export default "__VITE_ASSET__CWIhoAsF__"